<template>
  <div>
    <div class="t_out_box">
      <div
        style="
          background-color: white;
          padding: 30px 0 20px 0;
          margin-bottom: 11px;
          box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
          border-radius: 5px;
        "
      >
        <el-form
          class="t_search_form"
          style="width: 90%; margin-left: auto; margin-right: auto"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="化学品:" style="">
            <el-input
              v-model="searchForm.hxpMc"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="仓库名称:">
            <el-select v-model="searchForm.ckId" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in ckmcList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="出库日期:">
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.beginTime"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                :picker-options="startTime"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="3">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="searchForm.endTime"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                :picker-options="endTime"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="状态:" label-width="50px">
            <el-select v-model="searchForm.zt" placeholder="请选择">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button
            v-preventReClick
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            v-preventReClick
            class="chongzhiButton"
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
      <div class="t_con_w" style="padding-top: 40px; padding-bottom: 57px">
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <div
            style="
              background-color: #f4f4f4;
              padding: 12px 10px;
              border: 1px solid #f4f4f4;
            "
          >
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              type="primary"
              size="mini"
              style="background-color: #4170ff; border: none; color: white"
              @click="add(0)"
            >新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              size="mini"
              @click="copyAdd"
            >复制新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-upload2"
              size="mini"
              @click="exportExecl"
            >导出</el-button>
          </div>
          <el-table
            ref="qtckTable"
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            border
            :show-overflow-tooltip="true"
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column
              align="center"
              prop="ckbh"
              :show-overflow-tooltip="true"
              label="出库编号"
            />
            <el-table-column
              align="center"
              prop="hxpMc"
              :show-overflow-tooltip="true"
              label="化学品名称"
            />
            <el-table-column
              align="center"
              prop="ckMc"
              :show-overflow-tooltip="true"
              label="存放仓库"
            />
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              label="出库数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.cksl + scope.row.ckslDwMc }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="jbrxm"
              :show-overflow-tooltip="true"
              label="经办人"
            />

            <el-table-column
              align="center"
              prop="lyrq"
              :show-overflow-tooltip="true"
              label="出库日期"
            />
            <el-table-column align="center" prop="bgcs" label="变更次数">
              <template slot-scope="scope">
                <span
                  v-preventReClick
                  style="cursor: pointer"
                  @click="bgcsClick(scope.row)"
                >{{ scope.row.bgcs }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              :show-overflow-tooltip="true"
              label="状态"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.zt == '01'" style="color: #6fc89a">{{
                  scope.row.ztmc
                }}</span>
                <span
                  v-if="scope.row.zt == '21' || scope.row.zt == '11'"
                  style="color: #43a5e2"
                >{{ scope.row.ztmc }}</span>
                <span v-if="scope.row.zt == '00'" style="color: #333333">{{
                  scope.row.ztmc
                }}</span>
                <span v-if="scope.row.zt == '23'" style="color: red">{{
                  scope.row.ztmc
                }}</span>
                <span v-if="scope.row.zt == '24'" style="color: #6fc89a">{{
                  scope.row.ztmc
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="cz"
              width="200px"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.zt == '01' ||
                      scope.row.zt == '11' ||
                      scope.row.zt == '21' ||
                      scope.row.zt == '24' ||
                      scope.row.zt == '23'
                  "
                  v-preventReClick
                  size="mini"
                  icon="el-icon-document"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(2, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.zt == '01'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #feb800; border: none; color: white"
                  @click="add(3, scope.row)"
                >变更</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(4, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-delete"
                  style="background-color: #ff5721; border: none; color: white"
                  @click="deleteItem(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <el-dialog
      v-if="digshow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="digshow"
      width="1200px"
      @close="closeDialog"
    >
      <div v-loading="loading" class="t_dig">
        <div
          style="
            font-weight: bold;
            font-size: 20px;
            text-align: center;
            margin-bottom: 40px;
          "
        >
          {{ tetle }}
        </div>
        <div style="background-color: white">
          <div class="t_rk">
            <el-form
              ref="form"
              label-position="right"
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
              "
              label-width="100px"
              :model="qtchForm"
              :rules="rules"
            >
              <el-form-item
                label="化学品:"
                prop="hxpBm"
                style="margin-right: 0; width: 45%"
              >
                <el-cascader
                  v-if="!ckdisable && !bgdisable"
                  v-model="qtchForm.hxpBm"
                  :props="{ emitPath: false }"
                  :options="hxpList"
                  style="width: 100%"
                  @change="handleChange"
                />
                <el-input
                  v-else
                  v-model="qtchForm.hxpMc"
                  disabled
                />
              </el-form-item>

              <el-form-item
                label="存放仓库:"
                prop="ckId"
                style="margin-right: 0; width: 45%"
              >
                <el-select
                  v-if="!ckdisable"
                  v-model="qtchForm.ckId"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="cfckChange"
                >
                  <el-option
                    v-for="(item, index) in cfckList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="qtchForm.ckMc"
                  disabled
                />
              </el-form-item>
              <el-form-item
                v-if="!ckdisable"
                label="当前库存:"
                required
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="qtchForm.dqkc"
                  :disabled="true"
                  style="width: 60%"
                />
                <el-input
                  v-model="qtchForm.dqkcdwMc"
                  :disabled="true"
                  style="width: 35%; margin-left: 5%"
                />
              </el-form-item>
              <el-form-item
                label="出库数量:"
                prop="cksl"
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="qtchForm.cksl"
                  :disabled="ckdisable"
                  style="width: 60%"
                />
                <el-select
                  v-model="qtchForm.ckslDw"
                  :disabled="ckdisable"
                  placeholder="单位"
                  style="width: 35%; margin-left: 5%"
                >
                  <el-option
                    v-for="(item, index) in dwlxList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="保管员姓名:"
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="qtchForm.bgyxm"
                  :disabled="true"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="保管员电话:"
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="qtchForm.bgydh"
                  :disabled="true"
                  style="width: 100%"
                />
              </el-form-item>

              <el-form-item
                label="经办人:"
                prop="jbr"
                style="margin-right: 0; width: 45%"
              >
                <el-select
                  v-if="!ckdisable && !bgdisable"
                  v-model="qtchForm.jbr"
                  filterable
                  placeholder="经办人"
                  style="width: 100%"
                  @change="jbrChange"
                >
                  <el-option
                    v-for="(item, index) in jbrList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="qtchForm.jbrxm"
                  disabled
                />
              </el-form-item>
              <el-form-item
                label="出库日期:"
                prop="lyrq"
                style="margin-right: 0; width: 45%"
              >
                <el-date-picker
                  v-model="qtchForm.lyrq"
                  type="date"
                  :disabled="ckdisable"
                  style="width: 100%"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                />
              </el-form-item>
              <el-form-item
                label="出库原因:"
                style="margin-right: 0; width: 45%"
                prop="lyyy"
              >
                <el-input
                  v-model="qtchForm.lyyy"
                  :disabled="ckdisable || bgdisable"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="登记人:"
                required
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="djr"
                  :disabled="true"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                v-if="djsjshow || bgdisable"
                label="登记时间:"
                required
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="qtchForm.djsj"
                  :disabled="true"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item v-else label="登记时间:" style="margin-right: 0; width: 45%">
                <el-date-picker
                  :value="new Date()"
                  type="date"
                  style="width: 100%;"
                  placeholder="选择日期"
                  disabled
                  format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
              <el-form-item
                label="备注:"
                style="margin-right: 0; width: 100%"
                prop="bz"
              >
                <el-input
                  v-model="qtchForm.bz"
                  :disabled="ckdisable || bgdisable"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                v-if="bgdisable"
                label="变更理由:"
                prop="bgly"
                style="width: 100%"
                class="is-required tpcontent"
              >
                <el-input
                  v-model="qtchForm.bgly"
                  type="textarea"
                  :rows="3"
                  resize="none"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-form>
            <splcCom
              v-if="tetle == '查看其他出库' || tetle == '变更其他出库'"
              ref="splcRef"
            />
            <div
              v-if="
                curRowObj.bgcs >= 1 &&
                  (tetle == '查看其他出库' || tetle == '变更其他出库')
              "
              class=""
            >
              <div class="title" style="margin: 40px 0 50px 0">
                <img src="../assets/img/bgsp/ckbg.png" alt="" srcset="">
              </div>
              <bgcsOfDetail
                v-if="curRowObj.bgcs >= 1"
                :cur-row-obj="curRowObj"
                :cur-type="curType"
                :bgcs-t-k-name="'disShow'"
                @bacsCkXqShow="bacsCkXqShow"
              />
            </div>

            <div
              v-if="
                childrenType == 'copy' ||
                  childrenType == 'add' ||
                  childrenType == 'bj'
              "
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 18px;
                display: flex;
                justify-content: center;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  margin-right: 190px;
                  background-color: #ebebeb;
                  width: 148px;
                  height: 60px;
                  color: #333333;
                  border: none;
                "
                @click="saveTemp"
              >暂时保存</el-button>
              <el-button
                v-preventReClick
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                type="primary"
                @click="save(1)"
              >出库</el-button>
            </div>
            <div v-if="childrenType == 'ck'" class="backButton">
              <el-button
                v-preventReClick
                type="primary"
                @click="closeDialog"
              >确定</el-button>
            </div>
            <div v-if="childrenType == 'bg'" class="backButton">
              <el-button
                v-preventReClick
                type="primary"
                @click="submitBg"
              >提交变更</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        bgcs-t-k-name="其他出库"
        :dgcs-xq-id="dgcsXqId"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import splcCom from '../components/bgxq/splccom.vue'
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'

// 获取接口地址
import {
  addQtck,
  getLyrList,
  qtckliebiaoList,
  exportqtckList,
  qtckaddjckcl,
  editQtck,
  getqtckDetailList,
  deleteQtck,
  getHxpCascader,
  qtckbgjckcl,
  qtckbg, editQtckTemp, addQtckTemp
} from '@/assets/js/qtck.js'
import {
  ckOptions,
  statusOptionsNew,
  getListCkcx,
  userInfofLogin
} from '@/assets/js/common.js'
import { accMul } from '@/utils/number'
import { lengthValidate } from '@/assets/js/validate.js'
import { getdwforhxpBm } from '@/assets/js/yssq'
import bgcs from '@/components/bgcs'
import { isEmpty } from '@/utils/tool'
export default {
  name: 'Qtck',
  components: { bgcs, bgcsOfDetail, bgxqCom, splcCom },
  data() {
    const hxpJiaoyan = (rule, value, callback) => {
      /* if (!reg.test(value)) {
        callback(new Error("请输入大于或等于0的数量值"));
      } */
      if (!(this.qtchForm.cksl + '')) {
        callback(new Error('请输入出库数量!'))
      } else if ( !this.bgdisable &&
          /^(0|[1-9][0-9]*)(\.\d+)?$/.test(value) == false
      ) {
        callback(new Error('请输入大于或等于0的数量值'))
      }else if (
        /^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false
      ) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      } else if (!this.qtchForm.ckslDw) {
        callback(new Error('请选择出库数量单位!'))
      } else if (this.childrenType !== 'ck' && this.childrenType !== 'bg') {
        // 判断可购买额度

        // 吨：1    千克：2   克： 3    升： 4    毫升：5
        var rksl_hs = null
        if (this.qtchForm.ckslDw == '5' || this.qtchForm.ckslDw == '3') {
          rksl_hs = this.qtchForm.cksl
        } else if (this.qtchForm.ckslDw == '4' || this.qtchForm.ckslDw == '2') {
          // rksl_hs = this.qtchForm.cksl * 1000
          rksl_hs = accMul(this.qtchForm.cksl, 1000)
        } else if (this.qtchForm.ckslDw == '1') {
        //  rksl_hs = this.qtchForm.cksl * 1000 * 1000
          rksl_hs = accMul(this.qtchForm.cksl, 1000) * 1000
        }


        if (rksl_hs > this.temp_kgmed) {
          return callback(new Error('出库数量必须不大于当前库存量'))
        }
      }
      callback()
    }
    return {
      loading: false,
      tetle: '',
      bgcsTKName: '其他出库',
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endTime) {
            return time.getTime() > new Date(this.searchForm.endTime).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      temp_kgmed: 0,
      bgwindow: false,
      childrenType: '',
      checkedTableList: '',
      // 查看禁止
      ckdisable: false,
      // 变更禁止
      bgdisable: false,
      // 登记时间显示
      djsjshow: false,
      digshow: false,
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      cfckList: [], // 存放出库列表
      searchForm: { hxpMc: '', beginTime: '', endTime: '', zt: '', ckId: '' },
      ckmcList: [], // 下拉仓库名称
      statusList: [], // 状态
      hxpList: [], // 化学品list
      dwlxList: [], // 单位类型根据化学品获取
      jbrList: [], // 领用人list]
      djr: '', // 登记人
      qtchForm: {
        id: '',
        ckbh: '',
        hxpBm: '',
        hxpMc: '',
        ckId: '',
        ckMc: '',
        dqkc: '',
        dqkcdw: '',
        dqkcdwMc: '',
        cksl: '',
        ckslDw: '',
        ckslDwMc: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        jbr: '',
        jbrxm: '',
        lyrq: '',
        lyyy: '',
        bz: '',
        djrxm: '',
        djsj: ''
      }, // 弹框表单
      rules: {
        hxpBm: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ], // 化学品
        ckId: [
          { required: true, message: '请选择', trigger: ['blur','change'] }
        ], // 存放仓库
        cksl: [
          {
            required: true,
            validator: hxpJiaoyan,
            trigger: ['blur','change']
          }
        ], // validator: sljiaoyan,
        ckslbg: [
          { required: true, message: '请输入', trigger: ['blur'] }
        ],
        jbr: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ], //
        lyrq: [{ required: true, message: '请选择', trigger: 'change' }], // 报备日期
        lyyy: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        bz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        bgly: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible: false,
      dgcsXqId: null
    }
  },
  watch: {
    'qtchForm.hxpBm'(newValue, oldValue) {
      if (!isEmpty(newValue)) {
        // this.getCkxxAndJbr(newValue)
        getdwforhxpBm(newValue).then((e) => {
          this.dwlxList = e.data.data
        })
      }
    },
    'qtchForm.dqkc'(newValue, oldValue) {
      if (this.qtchForm.dqkcdw == '5' || this.qtchForm.dqkcdw == '3') {
        this.temp_kgmed = this.qtchForm.dqkc
      } else if (this.qtchForm.dqkcdw == '4' || this.qtchForm.dqkcdw == '2') {
        this.temp_kgmed = accMul(this.qtchForm.dqkc, 1000)
      } else if (this.qtchForm.dqkcdw == '1') {
        this.temp_kgmed = accMul(this.qtchForm.dqkc, 1000) * 1000
      }
    }
  },
  created() {
    // 获取首页仓库下拉
    getListCkcx().then((res) => {
      if (res.status == 200) {
        this.ckmcList = res.data.data
      }
    })
    statusOptionsNew().then((res) => {
      if (res.status == 200) {
        this.statusList = res.data.data
      }
    })
    userInfofLogin().then((e) => {
      this.djr = e.data.data.name
    })
    this.search()
  },
  methods: {
    lengthValidate,
    // 点击变更次数
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, '5')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 提交变更
    submitBg() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          qtckbgjckcl({
            id: this.qtchForm.id,
            hxpBm: this.qtchForm.hxpBm,
            ckId: this.qtchForm.ckId,
            cksl: this.qtchForm.cksl,
            ckslDw: this.qtchForm.ckslDw
          }).then((res) => {
            var data = '是否确认变更?'
            if (res.data.data.type == 'success') {
            }
            // 如果没有可注意事项
            else {
              data =
                "<span style='color:red'>" +
                res.data.data.msg +
                '</span>是否确认变更?'
            }
            this.$confirm(data, {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning',
              center: true
            })
              .then(() => {
                this.loading = true
                qtckbg(this.qtchForm).then((e) => {
                  this.loading = false
                  if (e.data.code == '000000') {
                    this.digshow = !this.digshow
                    this.search()
                    this.qtchForm = this.$options.data().qtchForm
                    this.$message({
                      message: '变更成功!',
                      type: 'success'
                    })
                  }
                }).catch((error) => {
                  this.loading = false
                })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
          })
        }
      })
    },
    // 删除记录
    deleteItem(row) {
      this.$confirm('是否删除本条信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteQtck(row.id).then((e) => {
            if (e.data.code == '000000') {
              this.search()
              this.$message({
                message: '删除成功!',
                type: 'success'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    closeDialog() {
      this.qtchForm = this.$options.data().qtchForm
      this.$refs['form'].resetFields()
      this.digshow = false
    },
    reset() {
      this.currentPage = 1
      this.pagesize = 10
      this.searchForm = this.$options.data().searchForm
      this.search()
    },
    search() {
      this.qtckliebiaoLists({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          hxpMc: this.searchForm.hxpMc,
          ckId: this.searchForm.ckId,
          beginTime: this.searchForm.beginTime,
          endTime: this.searchForm.endTime,
          zt: this.searchForm.zt
        }
      })
    },
    qtckliebiaoLists(dataObj) {
      qtckliebiaoList(dataObj).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    exportExecl() {
      exportqtckList({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          hxpMc: this.searchForm.hxpBm,
          ckId: this.searchForm.ckId,
          beginTime: this.searchForm.beginTime,
          endTime: this.searchForm.endTime,
          zt: this.searchForm.zt
        }
      }).then((e) => {
        const table = '其他出库'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 存放仓库回调
    cfckChange(val) {
      this.cfckList.filter((item, index) => {
        if (item.value == val) {
          this.qtchForm.bgyId = item.ckbgyId
          this.qtchForm.bgyxm = item.ckbgy
          this.qtchForm.bgydh = item.ckbgyDh
          this.qtchForm.dqkc = item.kcl
          this.qtchForm.dqkcdwMc = item.kclDwLabel
          this.qtchForm.ckMc = item.label
          this.qtchForm.ckId = item.value

          // 获取可购买额度 @y 便于运算
          if (item.kclDwLabel == '吨') {
            this.temp_kgmed = accMul(item.kcl, 1000) * 1000
          } else if (item.kclDwLabel == '千克' || item.kclDwLabel == '升') {
            this.temp_kgmed = accMul(item.kcl, 1000)
          } else if (item.kclDwLabel == '克' || item.kclDwLabel == '毫升') {
            this.temp_kgmed = item.kcl
          }
        }
      })
    },
    // 化学品选择触发
    handleChange(val) {
      this.qtchForm.ckId = ''
      this.qtchForm.ckMc = ''
      this.qtchForm.bgydh = ''
      this.qtchForm.bgyxm = ''
      this.qtchForm.dqkc = ''
      this.qtchForm.dqkcdwMc = ''
      this.qtchForm.ckslDw = ''
      this.getCkxxAndJbr(val)
    },
    getCkxxAndJbr(hxpBm, dataMes) {
      if (this.childrenType == 'bg') {
        ckOptions(hxpBm, dataMes.ckId).then((e) => {
          this.cfckList = e.data.data
          this.cfckChange(dataMes.ckId)
        })
      } else {
        if(hxpBm){
          ckOptions(hxpBm).then((e) => {
            this.cfckList = e.data.data
            if (dataMes && dataMes.ckId) {
              this.cfckChange(dataMes.ckId)
            }
          })
        }
        if (dataMes) {
          getLyrList().then((e) => {
            this.jbrList = e.data.data
            this.jbrList.findIndex((item) => {
              if (item.value == dataMes.jbr) {
                this.qtchForm.jbr = dataMes.jbr
                this.qtchForm.jbrxm = dataMes.jbrxm
                return
              }
            })
          })
        }
      }
    },
    handleSelectionChange(val) {
      this.checkedTableList = val
      if (val.length > 1) {
        this.$refs.qtckTable.clearSelection()
        this.$refs.qtckTable.toggleRowSelection(val.pop())
      }
    },
    copyAdd() {
      this.loadDataSource()
      if (this.checkedTableList == '') {
        this.$message.warning('请先选中一条数据!')
      } else {
        // 复制新增
        this.digshow = !this.digshow
        this.ckdisable = false
        this.djsjshow = false
        this.bgdisable = false
        this.childrenType = 'copy'
        this.tetle = '新增其他出库'
        getqtckDetailList(this.checkedTableList[0].id).then((e) => {
          const mesxx = { ...e.data.data }
          mesxx.ckId = this.qtchForm.ckId
          mesxx.ckMc = this.qtchForm.ckMc
          mesxx.bgydh = this.qtchForm.bgydh
          mesxx.bgyxm = this.qtchForm.bgyxm
          mesxx.jbr = this.qtchForm.jbr
          mesxx.jbrxm = this.qtchForm.jbrxm
          mesxx.dqkc = this.qtchForm.dqkc
          mesxx.dqkcdwMc = this.qtchForm.dqkcdwMc
          this.qtchForm = mesxx
          this.getCkxxAndJbr(e.data.data.hxpBm, e.data.data)
          this.$nextTick(() => {
            this.$refs.form ? this.$refs.form.clearValidate() : null//清楚页面所有校验结果
          })
        })
        this.checkedTableList = []
        this.$refs.qtckTable.clearSelection()
      }
    },
    /*
    00草稿  编辑删除
    01 已出库  查看和变更
    11 变更审批中  查看
    21 出库审批  查看
    */
    loadDataSource() {
      getHxpCascader().then((res) => {
        if (res.status == 200) {
          this.hxpList = res.data.data
        }
      })
    },

    // 变更次数模块
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.dialogFormVisibl = false
    },
    // 新增
    add(type, row) {
      this.curRowObj = {}
      this.loadDataSource()
      this.digshow = !this.digshow
      if (type == 0) {
        // 新增
        this.ckdisable = false
        this.djsjshow = false
        this.bgdisable = false
        this.childrenType = 'add'
        this.tetle = '新增其他出库'
        getLyrList().then((e) => {
          this.jbrList = e.data.data
        })
      } else if (type == 2) {
        // 查看
        this.ckdisable = true
        this.djsjshow = true
        this.bgdisable = false
        this.childrenType = 'ck'
        this.tetle = '查看其他出库'
        getqtckDetailList(row.id).then((e) => {
          this.qtchForm = e.data.data
          this.$refs.splcRef.dataobj = e.data.data.sphjDtoList
        })

        this.initCon(row, '5')
      } else if (type == 3) {
        // 变更
        this.ckdisable = false
        this.djsjshow = true
        this.bgdisable = true
        this.childrenType = 'bg'
        this.tetle = '变更其他出库'
        getqtckDetailList(row.id).then((e) => {
          const mesxx = { ...e.data.data }
          mesxx.ckId = this.qtchForm.ckId
          mesxx.ckMc = this.qtchForm.ckMc
          mesxx.bgydh = this.qtchForm.bgydh
          mesxx.bgyxm = this.qtchForm.bgyxm
          mesxx.dqkc = this.qtchForm.dqkc
          mesxx.dqkcdwMc = this.qtchForm.dqkcdwMc
          this.qtchForm = mesxx
          this.getCkxxAndJbr(e.data.data.hxpBm, e.data.data)
          this.$refs.splcRef.dataobj = e.data.data.sphjDtoList
          this.$delete(this.qtchForm, 'bgly')
        })
        this.initCon(row, '5')
      } else if (type == 4) {
        // 编辑
        this.ckdisable = false
        this.djsjshow = true
        this.bgdisable = false
        this.childrenType = 'bj'
        this.tetle = '编辑其他出库'
        getqtckDetailList(row.id).then((e) => {
          const mesxx = { ...e.data.data }
          mesxx.ckId = this.qtchForm.ckId
          mesxx.ckMc = this.qtchForm.ckMc
          mesxx.bgydh = this.qtchForm.bgydh
          mesxx.bgyxm = this.qtchForm.bgyxm
          mesxx.jbr = this.qtchForm.jbr
          mesxx.jbrxm = this.qtchForm.jbrxm
          mesxx.dqkc = this.qtchForm.dqkc
          mesxx.dqkcdwMc = this.qtchForm.dqkcdwMc
          this.qtchForm = mesxx
          this.getCkxxAndJbr(e.data.data.hxpBm, e.data.data)
          this.$nextTick(() => {
            this.$refs.form ? this.$refs.form.clearValidate() : null//清楚页面所有校验结果
          })
        })
      }
      this.checkedTableList = []
      this.$refs.qtckTable.clearSelection()
    },
    // 经办人切换
    jbrChange(val) {
      this.jbrList.filter((item, index) => {
        if (item.value == val) {
          this.qtchForm.jbrxm = item.label
        }
      })
    },
    // 暂时保存
    saveTemp() {
      this.$confirm('此操作将暂时保存为草稿，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.qtchForm.zt = '00'
        this.childrenType == 'copy'
            ? this.$delete(this.qtchForm, 'id')
            : ''
        if (this.childrenType == 'bj') {
          this.loading = true
          editQtckTemp(this.qtchForm).then((e) => {
            this.loading = false
            if (e.data.code == '000000') {
              this.$message({
                message: '暂时保存出库',
                type: 'success'
              })
              this.digshow = !this.digshow
              this.search()
              this.qtchForm = this.$options.data().qtchForm
            }
          }).catch((error) => {
            this.loading = false
          })
        } else {
          this.loading = true
          addQtckTemp(this.qtchForm).then((e) => {
            this.loading = false
            if (e.data.code == '000000') {
              this.$message({
                message: '暂时保存出库',
                type: 'success'
              })
              this.digshow = !this.digshow
              this.search()
              this.qtchForm = this.$options.data().qtchForm
            }
          }).catch((error) => {
            this.loading = false
          })
        }
      })
    },
    // 出库
    save(type) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          var ts =
            type == 0
              ? '此操作将暂时保存为草稿，是否继续?'
              : '此操作将不可撤回，是否继续?'
          this.$confirm(ts, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            qtckaddjckcl({
              hxpBm: this.qtchForm.hxpBm,
              ckId: this.qtchForm.ckId,
              cksl: this.qtchForm.cksl,
              ckslDw: this.qtchForm.ckslDw
            }).then((rs) => {
              if (rs.data.data.type == 'success') {
                // 0 暂时保存   1 出库
                this.qtchForm.zt = type == 0 ? '00' : '01'
                var arr = type == 0 ? '暂时保存出库!' : '提交出库!'
                this.childrenType == 'copy'
                  ? this.$delete(this.qtchForm, 'id')
                  : ''
                if (this.childrenType == 'bj') {
                  this.loading = true
                  editQtck(this.qtchForm).then((e) => {
                    this.loading = false
                    if (e.data.code == '000000') {
                      this.$message({
                        message: arr,
                        type: 'success'
                      })
                      this.digshow = !this.digshow
                      this.search()
                      this.qtchForm = this.$options.data().qtchForm
                    }
                  }).catch((error) => {
                    this.loading = false
                  })
                } else {
                  this.loading = true
                  addQtck(this.qtchForm).then((e) => {
                    this.loading = false
                    if (e.data.code == '000000') {
                      this.$message({
                        message: arr,
                        type: 'success'
                      })
                      this.digshow = !this.digshow
                      this.search()
                      this.qtchForm = this.$options.data().qtchForm
                    }
                  }).catch((error) => {
                    this.loading = false
                  })
                }
              } else {
                this.$message.error(rs.data.data.msg)
              }
            })
          })
        }
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    }
  }
}
</script>

<style scoped lang='less'>
.t_out_box {
  width: 95%;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1518px;
  /* background-color: white; */
}
.t_con_w {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
.t_search_btn {
  width: 90px;
  height: 39px;
  background-color: #4170ff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/* ------- */
.t_dig {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 10px;
}
.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  padding-bottom: 20px;
}
.sousuoButton {
  margin-left: 20px;
  color: #fff;
  background: #4170ff;
  border-color: #4170ff;
}
.el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;

  border: 1px solid #ebeef5;
  border-top: 0;
}
.backButton {
  width: 148px;
  margin: 30px auto 40px auto;
  .el-button {
    margin: 30px auto;
    background-color: #4170ff;
    width: 148px;
    height: 60px;
    color: white;
    border: none;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}

/deep/.el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}
</style>
